// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1qPZn","calendarButtons":"ClockData_calendarButtons__11bHe"};